/**
 *
 * TableFiltersList
 *
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  FilterList,
  FilterListContainer,
  ResetButton,
} from './TableFilterList.styles';
import { useTableFilters } from '../Table/providers/TableContext';

const areFiltersEmpty = (filters) => {
  // eslint-disable-next-line no-restricted-syntax,no-unused-vars
  for (const filter of Object.keys(filters)) {
    if (
      // Check if filter value is not null / undefined - mostly for query filters
      filters[filter] &&
      // If filter contains string or number, and that is not empty
      (((typeof filters[filter] === 'string' ||
        typeof filters[filter] === 'number') &&
        filters[filter].length) ||
        // If filter contains array, check if array is empty
        (Array.isArray(filters[filter]) && filters[filter].length))
    ) {
      return false;
    }
  }
  return true;
};

function TableFiltersList({ children }) {
  const { filters, resetFilters } = useTableFilters();
  const [filtersAvailable, setFiltersAvailable] = useState(false);

  useEffect(() => {
    setFiltersAvailable(!areFiltersEmpty(filters));
  }, [filters]);

  return (
    <FilterListContainer>
      <FilterList>{children}</FilterList>
      {filtersAvailable && (
        <ResetButton size="small" onClick={resetFilters}>
          Reset
        </ResetButton>
      )}
    </FilterListContainer>
  );
}

TableFiltersList.propTypes = {
  children: PropTypes.node,
};

export default TableFiltersList;
